export default "__VITE_ASSET__DT6JUfaW__"